/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-03-23, 15:41:17
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-05, 16:06:22
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import store from '@/store';

// change seconds do HHMMSS format
export const HHMMSS = (totalSeconds) => {
  let _totalSeconds = parseInt(totalSeconds, 0);
  if (_totalSeconds === 0 || Number.isNaN(_totalSeconds)) return '---';
  let hours = Math.floor(_totalSeconds / 3600);
  if (hours < 10) hours = `0${hours}`;
  _totalSeconds %= 3600;
  let minutes = Math.floor(_totalSeconds / 60);
  if (minutes < 10) minutes = `0${minutes}`;
  let seconds = _totalSeconds % 60;
  if (seconds < 10) seconds = `0${seconds}`;
  return `${hours}:${minutes}:${seconds}`;
};

// display number nine digit number, if there is no number, display '---'
export const displayNumber = (number) => {
  let _number = String(number).replace(/ /g, '');
  if (_number.match(/^\+?[0-9#*]+$/) !== null && _number.replace(/0/g, '').length) {
    return (_number.length === 9 && !isNaN(Number(_number))) ? `${_number.slice(0, 3)} ${_number.slice(3, 6)} ${_number.slice(6, 9)}` : `${_number}`;
  } return '---';
};

// check if value exists, if there is not - display word "Bezpłatne"
export const checkIfFree = value => ((value > 0) ? value : 'Bezpłatne');

// display value with two digits after comma
export const displayValue = function (value) {
  return parseFloat(value).toFixed(2).replace('.', ',');
};

// change bytes or kilobytes to KB, MB etc.
// source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
export const formatDataAccordingToAccountType = (bytes) => {
  const _bytes = Number(bytes);
  if (_bytes === 0) return '---';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const shiftSizes = store.getters.subscriber.type === 'postpaid' ? 1 : 0;
  const i = Math.floor(Math.log(_bytes) / Math.log(k));
  return `${parseFloat((_bytes / (k ** i)).toFixed(2))} ${sizes[i + shiftSizes]}`;
};

// format account number from string to properly IBAN number
export const formatToAccountNumber = number => (`PL${number}`).replace(/(.{4})(?!$)/g, '$1 ');

// Should return exactly the same value as the passed argument only if value in property "val" is included in array
export const returnOnlyIfValueIncludesInArray = (value, conditionObject = { val: null, condition: [] }) =>
  (conditionObject.condition.includes(conditionObject.val) ? value : null);

export const returnOnlyIfConditionIncludesInVal = (value, conditionObject = { val: null, condition: '' }) =>
  (conditionObject.val.includes(conditionObject.condition) ? value : null);



// WEBPACK FOOTER //
// ./src/filters/filters.js